import React from 'react';

const AppProvider = ( { children } ) => {
	return (
		<>{children}</>
	);
};

export default AppProvider;
